// src/components/BackToTop.js - Enhanced Version
import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

export default function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const toggleVisibility = () => {
      const scrolled = window.pageYOffset;
      const winHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrolledPercentage = (scrolled / winHeight) * 100;

      if (scrolled > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }

      setScrollProgress(scrolledPercentage);
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 left-6 z-40 group
                     bg-gradient-to-r from-blue-600 to-purple-600 
                     hover:from-blue-700 hover:to-purple-700
                     dark:from-blue-500 dark:to-purple-500
                     dark:hover:from-blue-600 dark:hover:to-purple-600
                     text-white p-4 rounded-full shadow-2xl 
                     transition-all duration-300 
                     hover:scale-110 hover:shadow-blue-500/50
                     animate-bounce-slow"
          aria-label="Scroll to top"
          style={{
            background: `conic-gradient(from 0deg, #3b82f6 ${scrollProgress}%, transparent ${scrollProgress}%)`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full m-1"></div>
          <ArrowUp className="w-5 h-5 relative z-10 group-hover:animate-bounce" />
        </button>
      )}

      <style jsx>{`
        @keyframes bounce-slow {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }
        
        .animate-bounce-slow {
          animation: bounce-slow 2s ease-in-out infinite;
        }
      `}</style>
    </>
  );
}